module.exports = __webpack_public_path__ + "static/anfmr-icon-6c1846d49c52babc52048677a682a7c0.png";